export default {
  MAX_ATTACHMENT_SIZE: 20000000,
  API_HOST: "http://ec2-18-228-191-89.sa-east-1.compute.amazonaws.com:8085"
};
